/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ recipients: NonNullable<unknown> }} Ccsl_Export_Recipient_OnlyInputs */



/**
* | output |
* | --- |
* | "TO: {recipients}" |
*
* @param {Ccsl_Export_Recipient_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_recipient_only = /** @type {((inputs: Ccsl_Export_Recipient_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Recipient_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`TO: ${i?.recipients}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`AN: ${i?.recipients}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`A: ${i?.recipients}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`КОМУ: ${i?.recipients}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`PARA: ${i?.recipients}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`收件人：${i?.recipients}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`宛先: ${i?.recipients}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रति: ${i?.recipients}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`PARA: ${i?.recipients}`)
	return /** @type {LocalizedString} */ (`TO: ${i?.recipients}`)
});